import React from 'react';
import _ from 'lodash';
import {Grid, Segment, Icon} from 'semantic-ui-react';
import {sortAndPartitionEmployeesByStartDate, safeAdd} from 'common/utils';
import EmployeeSlot from 'go/components/modules/roster/EmployeeSlot';

class Position extends React.Component {
  state = {
    expanded: false,
  };

  expand = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const {editEmployee, positionId, position, editable} = this.props;

    const {expanded} = this.state;

    const [activeEmployees, inactiveEmployees] = sortAndPartitionEmployeesByStartDate(
      position
    );

    const shouldDisplayHistory =
      safeAdd(_.size(inactiveEmployees), _.size(activeEmployees)) > 1;

    return (
      <Segment>
        <Grid>
          <Grid.Column width={3}>
            <Grid.Row>
              <strong>Position {positionId + 1}</strong>
            </Grid.Row>
            {shouldDisplayHistory && (
              <Grid.Row>
                <a href="#" onClick={this.expand}>
                  <Icon size="small" name={`chevron ${expanded ? 'down' : 'right'}`} />
                  <span className="padding-left--half">
                    {expanded ? 'Close position history' : 'View position history'}
                  </span>
                </a>
              </Grid.Row>
            )}
          </Grid.Column>
          <Grid.Column width={13}>
            {_.size(activeEmployees) === 0 ? (
              <EmployeeSlot
                employee={_.first(inactiveEmployees)}
                key={_.first(inactiveEmployees).rosterId}
                editEmployee={editEmployee}
                editable={editable}
              />
            ) : (
              _.map(activeEmployees, (employee, index) => (
                <EmployeeSlot
                  employee={employee}
                  key={employee.rosterId}
                  editEmployee={editEmployee}
                  isActive
                  editable={editable}
                />
              ))
            )}
            {expanded &&
              _.map(
                _.size(activeEmployees) === 0
                  ? _.tail(inactiveEmployees)
                  : inactiveEmployees,
                (employee, index) => (
                  <EmployeeSlot
                    employee={employee}
                    key={employee.rosterId}
                    divided={true}
                    editEmployee={editEmployee}
                    editable={editable}
                  />
                )
              )}
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default Position;
